












































import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../system/mixins";
import { ImelessTextarea } from "../../system";
import { BrowserUtility, BrowserKinds } from "../../../utilities";

@Component({
  components: {
    ImelessTextarea,
  },
})
export default class ExtraPagePositionInputDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      message: null as string,
      destinationPageNumber: null as string,
      sectionLength: null as number,
      result: null as number,
    };
  }
  message: string;
  destinationPageNumber: string;
  sectionLength: number;
  result: number;

  async show(message: string, nextSectionIndex: number, sectionLength: number): Promise<number> {
    return this.showModal(async () => {
      this.message = message;
      this.destinationPageNumber = (nextSectionIndex + 1).toString();
      this.sectionLength = sectionLength;
      this.result = null;
      this.$nextTick(() => {
        const element = this.$refs.addButton as HTMLButtonElement;
        if (element) { element.focus(); }
      });
      await this.waitHidden();
      return this.result;
    });
  }

  get isValidPosition(): boolean {
    if (!this.destinationPageNumber) { return false; }
    try {
      const destinationSectionIndex = Number(this.destinationPageNumber) - 1;
      return (destinationSectionIndex > 0) && (destinationSectionIndex <= this.sectionLength);
    } catch (e) {
      console.warn(e);
    }
    return false;
  }

  get shouldUseImelessTextarea(): boolean {
    return (BrowserUtility.getBrowserKind() !== BrowserKinds.InternetExplorer)
        && !BrowserUtility.isMobile();
  }

  addToSpecificPosition(): void {
    if (!this.isValidPosition) { return; }
    this.result = Number(this.destinationPageNumber) - 1;
    this.isVisible = false;
  }

  addToLast(): void {
    this.result = this.sectionLength;
    this.isVisible = false;
  }

  close(): void {
    this.result = null;
    this.isVisible = false;
  }
}
